import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.7.0_react@19.0.3/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.29.0_@playwright+test@1.60.0_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.29.0_@playwright+test@1.60.0_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["E"] */ "/vercel/path0/src/components/site-content/Editable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditBar"] */ "/vercel/path0/src/components/site-content/EditBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteContentProvider"] */ "/vercel/path0/src/components/site-content/SiteContent.tsx");
